import apis from '../apis/apis'

const phanHoiProcessor = {}
const controllerName = 'PhanHoi'

phanHoiProcessor.upsert = async (data) => {
  const rs = await apis[controllerName].Create({ method: 'post', responseType: 'text', data })
  return rs
}

export default phanHoiProcessor
